import React, { useContext, useEffect, useRef, useState, useImperativeHandle } from 'react'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import BackEndAPI from '../../../Services/BackEndAPI'
import { Button, Dialog, Grid, IconButton, Stack, Typography } from '@mui/material'
import { MensagemTipo } from '../../../GlobalStates/MensagemState'
import InputText from '../../../DevComponents/InputText'
import ClsValidacao from '../../../Utils/ClsValidacao'
import { PedidoItemInterface, rsERPEstoqueProdutoInterface, rsERPProdutoInterface } from '../../../ImportBackend/Interfaces/PedidoInterfaces'
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev'
import { EMDESENVOLVIMENTO } from '../../../ImportBackend/Config/emDesenvolvimento'
import PesquisarTabela from '../../../DevComponents/PesquisarTabela'
import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import ClsFormatacao from '../../../Utils/ClsFormatacao'
import Condicional from '../../../Layout/Condicional'

import ContentPaste from '@mui/icons-material/ContentPaste';
import { rsConsultaPrecoInterface } from '../../../ImportBackend/Interfaces/ERPInterfaces'

interface PropsInterface {
  idNaturezaOperacao: number
  idUnidadeFaturamento: number
  idCondicaoPagamento: number
  idRepresentante: number
  rsPedidoItens: Array<PedidoItemInterface>
  setRsPedidoItens: React.Dispatch<React.SetStateAction<PedidoItemInterface[]>>
  onTotalizarPedido: (rs: Array<PedidoItemInterface>) => void
  pasteItensCopiados: () => void
  rsClonePedido: number
  refazerPesquisaProdutos: React.MutableRefObject<(() => void) | undefined>
  /* Alteração de pedido: um pedido do ERP é de uma empresa só - 0 = sem restrição (inclusão) */
  idEmpresaAlteracao?: number
}

interface PesquisaInterface {
  descricao: string
  idProduto: number
  idUnidadeMedida: number
  descricaoProduto: string
}

enum StatusFormEnum {
  PESQUISANDO = 0,
  INCLUINDO_PRODUTO = 1,
  EDITANDO_PRODUTO = 2,
  EDITANDO_VALOR_UNITARIO = 3
}

enum CampoValorEdicaoAtualEnum {
  INICIAL = 0,
  EDICAO = 1
}

export default function PedidosItem({ idNaturezaOperacao, idUnidadeFaturamento, idCondicaoPagamento, rsPedidoItens, setRsPedidoItens, onTotalizarPedido, pasteItensCopiados, rsClonePedido, idRepresentante, refazerPesquisaProdutos, idEmpresaAlteracao = 0 }: PropsInterface) {

  const vrCasasDecimais = (valor: number, casasDecimais: number = 2): number => parseFloat(valor.toFixed(casasDecimais))

  const setFocusQuantidade = useRef(true)

  const contexto = useContext(ContextoGlobal) as ContextoGlobalInterface

  const clsFormatos: ClsFormatacao = new ClsFormatacao()

  const { setMensagemState } = (useContext(ContextoGlobal) as ContextoGlobalInterface)

  const campoValorEdicaoAtual = useRef<CampoValorEdicaoAtualEnum>(CampoValorEdicaoAtualEnum.INICIAL)

  const abortController: AbortController = new AbortController()

  const clsApi = new BackEndAPI()

  const [erros, setErros] = useState({})

  const [rsStatusForm, setRsStatusForm] = useState<StatusFormEnum>(StatusFormEnum.PESQUISANDO)

  const [rsProdutos, setRsProdutos] = useState<Array<rsConsultaPrecoInterface>>([])

  const ResetDados: PedidoItemInterface = {
    idProduto: 0,
    permitirEstoqueNegativo: false,
    valorCusto: 0,
    qtde_nao_fracionada: false,
    empresaIdentificador: 0,
    centroEstoqueIdentificador: 0,
    centroEstoque: '',
    produtoNome: '',
    percDescTrib: 0,
    valorDescontoTrib: 0,
    percDesconto: 0,
    valorDesconto: 0,
    valorUnitario: 0,
    valorTotal: 0,
    estoque: 0,
    percComissao: 0,
    valorSugerido: 0,
    valorMinimo: 0,
    valorMaximo: 0,
    unidadeMedidaIdentificador: 0,

    idPedidoItem: 0,
    idPedido: 0,
    tipoDescontoAcrescimoUnitario: true,
    percDescontoUnitario: 0,
    valorDescontoUnitario: 0,
    percAcrescimoUnitario: 0,
    valorAcrescimoUnitario: 0,
    percAcrescimo: 0,
    valorAcrescimo: 0,
    valorLiquido: 0,
    percDesoneracao: 0,
    valorDesoneracao: 0,
    quantidade: 0,
  }

  const [rsDados, setRsDados] = useState<PedidoItemInterface>(ResetDados)

  const [rsValorUnitario, setRsValorUnitario] = useState<PedidoItemInterface>(ResetDados)

  const editandoValorUnitario = useRef<boolean>(false)

  const [rsIndiceEdicao, setRsIndiceEdicao] = useState<number>(-1)

  const ResetPesquisa: PesquisaInterface = {
    descricao: '',
    idProduto: 0,
    idUnidadeMedida: 0,
    descricaoProduto: ''
  }

  const [pesquisa, setPesquisa] = useState<PesquisaInterface>(ResetPesquisa)

  const Cabecalho: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Estoque',
      campo: 'empresaIdentificador',
      alinhamento: 'left',
      format: (_rs, row: rsConsultaPrecoInterface) => row.empresa
    },
    {
      cabecalho: 'Pendente',
      campo: 'quantidadePendente',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs, 0)
    },
    {
      cabecalho: 'Saldo',
      campo: 'estoque',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs, 0)
    },
    {
      cabecalho: 'Valor',
      campo: 'empresaIdentificador',
      alinhamento: 'right',
      format: (_rs, row: rsConsultaPrecoInterface) => clsFormatos.currency(row.dados?.valorTotalComImpostos ?? 0)
    }
  ]
  const CabecalhoItens: Array<DataTableCabecalhoInterface> = [
    {
      cabecalho: 'Produto',
      campo: 'produtoNome',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Estoque',
      campo: 'centroEstoque',
      alinhamento: 'left'
    },
    {
      cabecalho: 'Qtd',
      campo: 'quantidade',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr. Unitário',
      campo: 'valorUnitario',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '% Desc. Trib.',
      campo: 'percDescTrib',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr. Desc. Trib.',
      campo: 'valorDescontoTrib',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr. Total',
      campo: 'valorTotal',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '% Desc',
      campo: 'percDesconto',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '$ Desc',
      campo: 'valorDesconto',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '% Acréscimo',
      campo: 'percAcrescimo',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '$ Acréscimo',
      campo: 'valorAcrescimo',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: '$ Desoneração',
      campo: 'valorDesoneracao',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    },
    {
      cabecalho: 'Vr. a Pagar',
      campo: 'valorLiquido',
      alinhamento: 'right',
      format: (rs) => clsFormatos.currency(rs)
    }
  ]

  const validarDados = (): boolean => {

    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.naoVazio('quantidade', rsDados, erros, retorno)

    if (retorno) {

      if (rsDados.quantidade > rsDados.estoque && !rsDados.permitirEstoqueNegativo) {
        erros.quantidade = 'Saldo menor que quantidade'
        retorno = false
      }

      if (rsDados.qtde_nao_fracionada && !Number.isInteger(rsDados.quantidade)) {
        erros.quantidade = 'Este produto não permite quantidade fracionada'
        retorno = false
      }

      if (rsDados.percDesconto > contexto.loginState.perDescontoMaximo) {
        erros.percDesconto = 'Desconto maior que o permitido'
        retorno = false
      }

    }

    setErros(erros)

    return retorno

  }

  const onChangeProduto = (rs: rsERPProdutoInterface) => {

    if (rs && rs.ID_PRODUTO) {

      setPesquisa({ ...pesquisa, idProduto: rs.ID_PRODUTO, idUnidadeMedida: rs.ID_UNIDADE_MEDIDA, descricaoProduto: rs.NOME })

      pesquisarPrecos(rs.ID_PRODUTO)

    }
  }

  const pesquisarPrecos = (idProduto: number) => {

    const query: string = `
      getERPEstoqueProdutoValor (
        idProduto: ${idProduto},
        idUnidadeFaturamento: ${idUnidadeFaturamento},
        idRepresentante: ${idRepresentante},
        idCondicaoPagamento: ${idCondicaoPagamento},
        idNaturezaOperacao: ${idNaturezaOperacao}
      ) {
        dados {
          identificador
          valorUnitario
          valorUnitarioDescTrib
          valorFrete
          valorDesconto
          valorTotalBruto
          valorTotal
          valorBancoCredito
          valorFabrica
          percComissao
          percDesconto
          percFrete
          percDespesaAcessoria
          percSeguro
          valorDespesaAcessoria
          valorSeguro
          valorSugerido
          valorMinimo
          valorMaximo
          modeloFiscalIdentificador
          modeloFiscal
          tabDesFinancProdutoIdentificador
          tabDesFinancProduto
          classificacaoVendasIdentificador
          classificacaoVendas
          produtoIdentificador
          produto
          produtoNome
          produtoCodigoAuxiliar
          unidadeMedidaIdentificador
          unidadeMedida
          quantidadeTotal
          gradeItemPedido {
            identificador
            gradeCorIdentificador
            gradeCor
            gradeCorHexCor
            gradeCorSigla
            quantidade
            reservarEstoque
          }
          fatorConversao
          infoAdicionalItem
          infoAdicionalItemAux
          tipoCondicao
          codigoAux
          descricaoAux
          nrItemPedido
          itemPedidoFiscal {
            identificador
            itemPedidoIdentificador
            itemPedido
            aliquotaIcms
            vrIcmsTributado
            vrIcmsIsento
            vrIcmsOutros
            vrIcms
            vrIcmsSemAprov
            vrDifAliquota
            vrIpiTributado
            vrIpiIsento
            vrIpiOutros
            vrIpiIndustria
            vrIpiComercio
            vrIpiObservacao
            vrBcCalculoIcmsSt
            vrBcCalculoIcms
            vrIcmsSt
            vrIrrf
            vrIss
            vrInss
            vrInssNaoRetido
            vrCofins
            vrLei10833
            vrOutros
            vrFunrural
            aliquotaIpi
            indPeriodoApuracao
            vrDespAduaneira
            vrImpostoImportacao
            vrBCImpostoImp
            vrIof
            vrCofinsSt
            vrPisSt
            vrPis
            percReducaoBCIcms
            aliquotaIcmsST
            descontoPadraoIcmsST
            indiceAlteracaoIcmsST
            vrContSoc
            aliquotaFunrural
            aliquotaIss
            aliquotaContSoc
            aliquotaLei10833
            aliquotaInss
            aliquotaPis
            aliquotaCofins
            aliquotaOutros
            aliquotaIrrf
            aliquotaSestSenat
            percRedBcInss
            percRedSestSenat
            valorSestSenat
            calcularIcmsST
            percRedFunrural
            percRedIrrf
            percRedOutros
            percRedLei10833
            percRedContSoc
            vrfreteIcmsST
            vrNaoTribIcms
            baseCalcIcmsFreteST
            vrCustoICMSST
            vrBCCustoICMSST
            vrDevICMSST
            vrBCDevICMSST
            vrICMSSTRet
            vrBCICMSSTRet
            vrICMSDispensado
            aliquotaICMSSimples
            valorICMSSimples
            vrBCPis
            vrBCCofins
            aliquotaCIDE
            quantidadeBCCIDE
            valorCIDE
            qtdCombTempAmb
            ufConsumoCombIdentificador
            ufConsumoComb
            incidenciaPisCofinsIdentificador
            incidenciaPisCofins
            incidenciaIcmsIdentificador
            incidenciaIcms
            incidenciaIpiIdentificador
            incidenciaIpi
            ufIcmsStIdentificador
            ufIcmsSt
            modalidadeIcmsStIdentificador
            modalidadeIcmsSt
            modalidadeIcmsIdentificador
            modalidadeIcms
            categoriaStIdentificador
            categoriaSt
            valorBCFCP
            aliquotaFCP
            valorFCP
            valorBCFCPSt
            aliquotaFCPSt
            valorFCPSt
            valorBCFCPStRetido
            aliquotaFCPStRetido
            valorFCPStRetido
            percentualDiferimento
            valorIcmsDiferimento
            aliquotaPisSt
            aliquotaCofinsSt
            vrBCPisSt
            vrBCCofinsSt
            valorBcIcmsUfDest
            aliquotaInternaUFDest
            aliquotaInterestadual
            percPartilhaIcms
            valorIcmsPartilhaDest
            valorIcmsPartilhaRem
            aliquotaFundoPobreza
            valorFundoPobreza
          }
          valorDescFinanceiro
          nrSequencial
          quantidadePecas
          descontoItem
          despAcessItem
          seguroItem
          freteItem
          tipoDesconto
          tipoFrete
          tipoSeguro
          tipoDespAcessoria
          valorTotalComImpostos
          centroEstoqueIdentificador
          centroEstoque
          prazoEntrega
          nrPedido
          itemCotacaoVendasIdentificador
          itemCotacaoVendas
          percComissaoMin
          percComissaoMax
          valorCusto
          formTabDinCalcPrecoIdentificador
          formTabDinCalcPreco
          formTabDinCalcComissaoIdentificador
          formTabDinCalcComissao
          tipoTabPreco
          dataAtualizacao
          grupoProdutosIdentificador
          grupoProdutos
          percDescTrib
          valorTotalBrutoDescTrib
          valorTotalDescTrib
          dataEntrega
          percDescontoItemInf
          percFreteItemInf
          percDespAcessItemInf
          percSeguroItemInf
          valorDescontoItemInf
          valorFreteItemInf
          valorDespAcessItemInf
          valorSeguroItemInf
          percDescontoRateado
          percFreteRateado
          percDespAcessRateado
          percSeguroRateado
          valorDescontoRateado
          valorFreteRateado
          valorSeguroRateado
          valorDespAcessRateado
          percDescontoTrib
          valorDescontoTrib
          nrLoteFabricacao
          dataFabricacao
          dataValidade
          analisePrecoVenda
          analisePrecoVendaIdentificador
          valorDescontoPromocional
          percDescontoPromocional
          errors
          tabelaPromocao
          paramTribCbsIbsClassIdentificador
        }
        quantidadePendente
        permitirEstoqueNegativo
        idProduto
        qtde_nao_fracionada
        percDesoneracao
        empresaIdentificador
        empresa
        estoque
        modoArredondamento
        status
        observacoes {
          codMessage
          fieldName
          message
          status
        }
      }
    `

    clsApi.query<Array<rsConsultaPrecoInterface>>(query, 'getERPEstoqueProdutoValor', 'Pesquisando Produtos...', contexto, abortController).then((rs) => {

      setRsProdutos(idEmpresaAlteracao > 0 ? rs.filter(v => v.empresaIdentificador === idEmpresaAlteracao) : rs)

    }).catch((e) => {

      setMensagemState({
        cb: null,
        exibir: true,
        exibirBotao: true,
        mensagem: 'Erro na Consulta do ERP - '.concat(e),
        tipo: MensagemTipo.Error,
        titulo: 'Erro ERP!'
      })

    })

    return () => {

      abortController.abort()
    }
  }

  const onApagarProduto = (indice: number) => {
    let tmp = [...rsPedidoItens]

    tmp.splice(indice, 1)
    setRsIndiceEdicao(0)

    setRsPedidoItens(tmp)

    onTotalizarPedido(tmp)
  }

  const onAdicionarProduto = (rs: rsConsultaPrecoInterface) => {

    let indice = rsPedidoItens.findIndex(v => v.idProduto === rs.idProduto && v.empresaIdentificador === rs.empresaIdentificador && v.centroEstoqueIdentificador === rs.dados?.centroEstoqueIdentificador)

    // Se produto já existe... Se não, inclui um novo...
    if (indice >= 0) {
      setRsDados(rsPedidoItens[indice])
    } else {

      const tmpDados: PedidoItemInterface = {
        idPedidoItem: 0,
        idPedido: 0,
        empresaIdentificador: rs.empresaIdentificador,
        centroEstoqueIdentificador: rs.dados?.centroEstoqueIdentificador ?? 0,
        centroEstoque: rs.dados?.centroEstoque ?? '',
        produtoNome: pesquisa.descricaoProduto,
        idProduto: rs.idProduto,
        // 2 casas, igual ao enviado ao ERP (converterEmFloat) - com o unitário cru (ex.: 87,443946) o bruto
        // divergia do ERP em quantidades maiores (13 × 87,443946 = 1.136,77 x ERP 13 × 87,44 = 1.136,72)
        valorUnitario: vrCasasDecimais(rs.dados?.valorUnitario ?? 0),
        estoque: rs.estoque,
        permitirEstoqueNegativo: rs.permitirEstoqueNegativo,
        qtde_nao_fracionada: rs.qtde_nao_fracionada,
        valorTotal: 0,
        valorLiquido: 0,
        percDesoneracao: rs.percDesoneracao ?? 0,
        valorDesoneracao: 0,
        percComissao: rs.dados?.percComissao ?? 0,
        tipoDescontoAcrescimoUnitario: true,
        percDescontoUnitario: 0,
        valorDescontoUnitario: 0,
        percAcrescimoUnitario: 0,
        valorAcrescimoUnitario: 0,
        percDesconto: 0,
        valorDesconto: 0,
        percAcrescimo: 0,
        valorAcrescimo: 0,
        quantidade: 0,
        valorSugerido: rs.dados?.valorSugerido ?? 0,
        valorMinimo: rs.dados?.valorMinimo ?? 0,
        valorMaximo: rs.dados?.valorMaximo ?? 0,
        unidadeMedidaIdentificador: pesquisa.idUnidadeMedida,
        percDescTrib: rs.dados?.percDescTrib ?? 0,
        valorDescontoTrib: vrCasasDecimais((rs.dados?.valorSugerido ?? 0) * (1 - (rs.dados?.percDescTrib ?? 0) / 100)),
        valorCusto: rs.dados?.valorCusto ?? 0,
      }

      indice = -1

      setRsDados(tmpDados)

    }

    setRsIndiceEdicao(indice)

    setRsStatusForm(StatusFormEnum.EDITANDO_PRODUTO)

    setFocusQuantidade.current = true

  }

  const btCancelarItem = () => {
    setRsDados(ResetDados)
    setRsStatusForm(StatusFormEnum.PESQUISANDO)
  }

  const btConfirmarItem = () => {
    if (validarDados()) {

      let tmpPedidoItens = [...rsPedidoItens]

      if (rsIndiceEdicao >= 0) {
        tmpPedidoItens[rsIndiceEdicao] = { ...rsDados }
      } else {
        tmpPedidoItens.push({ ...rsDados })
      }

      setRsPedidoItens(tmpPedidoItens)
      onTotalizarPedido(tmpPedidoItens)

      setPesquisa(ResetPesquisa)
      setRsProdutos([])

      setRsStatusForm(StatusFormEnum.PESQUISANDO)

      focarCampo('ID_PRODUTO', 'text')
    }
  }

  const onAlterarPerDesconto = (rs: number) => {

    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {

      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO

      let tmpDados = { ...rsDados }

      let percentual: number = typeof rs === 'number' && tmpDados.quantidade > 0 ? rs : 0

      if (percentual <= contexto.loginState.perDescontoMaximo) {
        tmpDados.percDesconto = percentual
        tmpDados.percDescontoUnitario = percentual
      } else {
        setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: 'Desconto Excede o Limite!',
          tipo: MensagemTipo.Warning,
          titulo: 'Atenção!'
        })
        tmpDados.percDesconto = 0
        tmpDados.percDescontoUnitario = 0
      }

      tmpDados.valorTotal = vrCasasDecimais((tmpDados.valorUnitario * tmpDados.quantidade))
      tmpDados.valorDesconto = vrCasasDecimais((tmpDados.valorTotal * tmpDados.percDesconto / 100))
      tmpDados.valorDescontoUnitario = tmpDados.quantidade > 0 ? vrCasasDecimais((tmpDados.valorDesconto / tmpDados.quantidade)) : 0

      tmpDados.valorAcrescimo = 0
      tmpDados.percAcrescimo = 0
      tmpDados.valorAcrescimoUnitario = 0
      tmpDados.percAcrescimoUnitario = 0

      setRsDados(calcularValorLiquido(tmpDados))

    }

  }

  const calcularValorLiquido = (tmpDados: PedidoItemInterface) => {

    let retorno = { ...tmpDados }

    // Metodologia do ERP: desconto/acréscimo aplicado sobre o total bruto (valorUnitario × quantidade),
    // nunca sobre o unitário arredondado - (valorUnitario - valorDescontoUnitario) × quantidade diverge
    // em centavos do total calculado pelo ERP (ver documentacao.md §2.5).
    const valorTotalBruto: number = vrCasasDecimais((retorno.valorUnitario * retorno.quantidade))
    retorno.valorTotal = vrCasasDecimais((valorTotalBruto - retorno.valorDesconto + retorno.valorAcrescimo))

    retorno.valorDescontoTrib = vrCasasDecimais((retorno.valorTotal * (1 - retorno.percDescTrib / 100)) / retorno.quantidade)

    // Desoneração de ICMS - regra do ERP, conferida ao centavo em pedidos reais (documentacao.md §13): base =
    // bruto - desconto (o acréscimo não entra). valorLiquido é o valor a pagar - base dos títulos.
    retorno.valorDesoneracao = vrCasasDecimais(((valorTotalBruto - retorno.valorDesconto) * (retorno.percDesoneracao ?? 0) / 100))
    retorno.valorLiquido = vrCasasDecimais((vrCasasDecimais((retorno.valorTotal * (1 - retorno.percDescTrib / 100))) - retorno.valorDesoneracao))

    /*
    console.clear()
    console.log(
      'retorno.tipoDescontoAcrescimoUnitario', retorno.tipoDescontoAcrescimoUnitario,
      'retorno.vrUnitario', retorno.vrUnitario,
      'retorno.valorDescontoUnitario', retorno.valorDescontoUnitario,
      'retorno.valorAcrescimoUnitario', retorno.valorAcrescimoUnitario,
      'retorno.quantidade', retorno.quantidade,
      'retorno.vrDescontoTributario', retorno.vrDescontoTributario,
      'retorno.perDescontoTributario', retorno.perDescontoTributario,
      'retorno.vrTotal', retorno.vrTotal,
    )
      */

    // retorno.vrDescontoTributario = vrCasasDecimais( ( ( retorno.vrUnitario - retorno.valorDescontoUnitario + retorno.valorAcrescimoUnitario ) * ( 1 - retorno.perDescontoTributario / 100 ) ) )


    // retorno.valorLiquido = vrCasasDecimais( ( ( retorno.vrTotal - retorno.vrDesconto + retorno.valorAcrescimo - retorno.vrDescontoTributario ) ) )

    // console.log('PÓS calcularValorLiquido', retorno.vrTotal, retorno.vrUnitario, retorno.vrDesconto)

    return retorno
  }

  const onAlterarValorDesconto = (rs: number) => {

    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {

      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO

      let tmpDados = { ...rsDados }

      // Se for DescontoUnitário, calcula os percentuais e transforma em desconto total
      if (tmpDados.tipoDescontoAcrescimoUnitario) {
        tmpDados.valorDescontoUnitario = rs
        rs = vrCasasDecimais((tmpDados.valorDescontoUnitario * tmpDados.quantidade))
      } else {
        tmpDados.valorDescontoUnitario = vrCasasDecimais((rs / tmpDados.quantidade))
      }

      tmpDados.percDescontoUnitario = vrCasasDecimais((tmpDados.valorDescontoUnitario / tmpDados.valorUnitario * 100))

      tmpDados.valorTotal = vrCasasDecimais((tmpDados.valorUnitario * tmpDados.quantidade))

      let percentual: number = typeof rs === 'number' ? vrCasasDecimais((rs / tmpDados.valorTotal * 100)) : 0

      if (percentual <= contexto.loginState.perDescontoMaximo) {
        tmpDados.percDesconto = percentual
        tmpDados.valorDesconto = rs
      } else {
        setMensagemState({
          cb: null,
          exibir: true,
          exibirBotao: true,
          mensagem: 'Desconto Excede o Limite!',
          tipo: MensagemTipo.Warning,
          titulo: 'Atenção!'
        })
        tmpDados.percDesconto = 0
        tmpDados.valorDesconto = 0
        tmpDados.valorDescontoUnitario = 0
        tmpDados.percDescontoUnitario = 0
      }

      tmpDados.valorAcrescimo = 0
      tmpDados.percAcrescimo = 0
      tmpDados.percAcrescimoUnitario = 0
      tmpDados.valorAcrescimoUnitario = 0

      setRsDados(calcularValorLiquido(tmpDados))

    }

  }

  const onAlterarPerAcrescimo = (rs: number) => {

    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {

      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO

      let tmpDados = { ...rsDados }

      let percentual: number = typeof rs === 'number' && tmpDados.quantidade > 0 ? rs : 0

      tmpDados.percAcrescimo = rs
      tmpDados.percAcrescimoUnitario = rs
      tmpDados.valorTotal = vrCasasDecimais((tmpDados.valorUnitario * tmpDados.quantidade))
      tmpDados.valorAcrescimo = vrCasasDecimais((tmpDados.valorTotal * percentual / 100))
      tmpDados.valorAcrescimoUnitario = tmpDados.quantidade > 0 ? vrCasasDecimais((tmpDados.valorAcrescimo / tmpDados.quantidade)) : 0

      tmpDados.valorDesconto = 0
      tmpDados.percDesconto = 0
      tmpDados.valorDescontoUnitario = 0
      tmpDados.percDescontoUnitario = 0

      setRsDados(calcularValorLiquido(tmpDados))

    }

  }

  const onAlterarValorAcrescimo = (rs: number) => {

    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {

      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO

      let tmpDados = { ...rsDados }

      // Se for acréscimo unitário, calcula os percentuais e transforma em acréscimo total
      if (tmpDados.tipoDescontoAcrescimoUnitario) {
        tmpDados.valorAcrescimoUnitario = rs
        rs = vrCasasDecimais((tmpDados.valorAcrescimoUnitario * tmpDados.quantidade))
      } else {
        tmpDados.valorAcrescimoUnitario = vrCasasDecimais((rs / tmpDados.quantidade))
      }

      tmpDados.percAcrescimoUnitario = vrCasasDecimais((tmpDados.valorAcrescimoUnitario / tmpDados.valorUnitario * 100))

      tmpDados.valorTotal = vrCasasDecimais((tmpDados.valorUnitario * tmpDados.quantidade))

      let percentual: number = typeof rs === 'number' ? vrCasasDecimais((rs / tmpDados.valorTotal * 100)) : 0

      tmpDados.percAcrescimo = typeof percentual === "number" ? percentual : tmpDados.percAcrescimoUnitario
      tmpDados.valorAcrescimo = rs

      tmpDados.valorDesconto = 0
      tmpDados.percDesconto = 0
      tmpDados.percDescontoUnitario = 0
      tmpDados.valorDescontoUnitario = 0

      setRsDados(calcularValorLiquido(tmpDados))

    }

  }

  const onAlterarTipoDescontoAcrescimoUnitario = (rs: boolean) => {
    if (campoValorEdicaoAtual.current === CampoValorEdicaoAtualEnum.INICIAL && !editandoValorUnitario.current) {
      campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.EDICAO
      setRsDados({ ...rsDados, tipoDescontoAcrescimoUnitario: rs })
    }
  }

  useEffect(() => {
    setRsProdutos([])
  }, [idNaturezaOperacao])

  useEffect(() => {

    campoValorEdicaoAtual.current = CampoValorEdicaoAtualEnum.INICIAL

  })

  useEffect(() => {

    const txtQuantidade = document.getElementsByName('quantidade')[0]

    if (txtQuantidade && setFocusQuantidade.current) {

      setFocusQuantidade.current = false

      txtQuantidade.focus()

      //@ts-ignore
      txtQuantidade.select()

    } else {
      const txtIdProduto = document.getElementsByName('ID_PRODUTO')[0]

      if (txtIdProduto) {
        txtIdProduto.focus()
      }
    }

  })

  const onAlterarQuantidade = (rs: number) => {

    let quantidade: number = typeof rs === 'number' ? rs : 0

    let tmpDados = { ...rsDados }
    tmpDados.valorTotal = vrCasasDecimais((tmpDados.valorUnitario * quantidade))

    // Mantém o percentual e recalcula o valor sobre o novo total bruto (metodologia do ERP) - recompor
    // pelo unitário arredondado (quantidade × valorDescontoUnitario) diverge em centavos.
    tmpDados.valorAcrescimo = vrCasasDecimais((tmpDados.valorTotal * tmpDados.percAcrescimo / 100))
    tmpDados.valorAcrescimoUnitario = quantidade > 0 ? vrCasasDecimais((tmpDados.valorAcrescimo / quantidade)) : 0
    tmpDados.percAcrescimoUnitario = tmpDados.percAcrescimo

    tmpDados.valorDesconto = vrCasasDecimais((tmpDados.valorTotal * tmpDados.percDesconto / 100))
    tmpDados.valorDescontoUnitario = quantidade > 0 ? vrCasasDecimais((tmpDados.valorDesconto / quantidade)) : 0
    tmpDados.percDescontoUnitario = tmpDados.percDesconto

    tmpDados.quantidade = quantidade

    setRsDados(calcularValorLiquido(tmpDados))

  }

  const focarCampo = (campo: string, tipo: 'text' | 'button') => {

    const txtCampo = document.getElementsByName(campo)[0]

    if (txtCampo) {

      txtCampo.focus()
      if (tipo === 'text') {
        //@ts-ignore
        txtCampo.select()
      }
    }

  }

  const onEditarProduto = (indice: number) => {
    setRsDados(rsPedidoItens[indice])
    setRsValorUnitario(rsPedidoItens[indice])
    setRsIndiceEdicao(indice)
    setRsStatusForm(StatusFormEnum.EDITANDO_PRODUTO)
  }

  // Alteração de Valor Unitário do Produto
  const onEditarValorUnitario = (indice: number) => {
    setRsValorUnitario({ ...rsPedidoItens[indice] })
    setRsIndiceEdicao(indice)
    setRsStatusForm(StatusFormEnum.EDITANDO_VALOR_UNITARIO)
  }

  const btCancelarEdicaoValorUnitario = () => {
    setRsStatusForm(StatusFormEnum.PESQUISANDO)
  }

  const onAlterarValorUnitario = (rsValorUnitario: PedidoItemInterface) => {

    let tmpDados: PedidoItemInterface = { ...rsValorUnitario }
    const valorUnitario: number = rsPedidoItens[rsIndiceEdicao].valorUnitario

    tmpDados.valorAcrescimoUnitario = rsValorUnitario.valorUnitario > valorUnitario ? parseFloat((rsValorUnitario.valorUnitario - valorUnitario).toFixed(2)) : 0
    tmpDados.valorDescontoUnitario = rsValorUnitario.valorUnitario < valorUnitario ? parseFloat((valorUnitario - rsValorUnitario.valorUnitario).toFixed(2)) : 0

    tmpDados.valorUnitario = parseFloat(valorUnitario.toFixed(2))

    // Se for Acrescimo
    if (tmpDados.valorAcrescimoUnitario > 0) {

      tmpDados.percAcrescimoUnitario = parseFloat((tmpDados.valorAcrescimoUnitario / tmpDados.valorUnitario * 100).toFixed(2))

      tmpDados.valorTotal = parseFloat((tmpDados.valorUnitario * tmpDados.quantidade).toFixed(2))

      tmpDados.percAcrescimo = tmpDados.percAcrescimoUnitario

      tmpDados.valorAcrescimo = parseFloat((tmpDados.valorAcrescimoUnitario * tmpDados.quantidade).toFixed(2))


      tmpDados.valorDesconto = 0
      tmpDados.percDesconto = 0
      tmpDados.percDescontoUnitario = 0
      tmpDados.valorDescontoUnitario = 0

      tmpDados = calcularValorLiquido(tmpDados)

    }

    // Se for Desconto
    if (tmpDados.valorDescontoUnitario > 0) {

      tmpDados.percDescontoUnitario = parseFloat((tmpDados.valorDescontoUnitario / tmpDados.valorUnitario * 100).toFixed(2))

      tmpDados.valorTotal = parseFloat((tmpDados.valorUnitario * tmpDados.quantidade).toFixed(2))

      tmpDados.percDesconto = tmpDados.percDescontoUnitario

      tmpDados.valorDesconto = parseFloat((tmpDados.valorDescontoUnitario * tmpDados.quantidade).toFixed(2))

      tmpDados.valorAcrescimo = 0
      tmpDados.percAcrescimo = 0
      tmpDados.percAcrescimoUnitario = 0
      tmpDados.valorAcrescimoUnitario = 0

      tmpDados = calcularValorLiquido(tmpDados)

    }

    if (tmpDados.percDesconto <= contexto.loginState.perDescontoMaximo) {

      const tmpPedidoItens: Array<PedidoItemInterface> = JSON.parse(JSON.stringify(rsPedidoItens))
      tmpPedidoItens[rsIndiceEdicao] = tmpDados
      setRsPedidoItens(tmpPedidoItens)
      onTotalizarPedido(tmpPedidoItens)

    } else {

      setMensagemState({
        cb: null,
        exibir: true,
        exibirBotao: true,
        mensagem: 'Desconto Excede o Limite!',
        tipo: MensagemTipo.Warning,
        titulo: 'Atenção!'
      })
      tmpDados.percDesconto = 0
      tmpDados.percDescontoUnitario = 0

    }

    setRsStatusForm(StatusFormEnum.PESQUISANDO)

  }

  useImperativeHandle(refazerPesquisaProdutos, () => () => {
    setRsProdutos([])
  }, [])

  return (
    <>

      <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
          <Typography component="h5" variant="h5" align="left">
            Itens do Pedido
            {/*
              <Typography variant="body2" gutterBottom>
              Pesquisa por Código, Auxiliar, Descrição ou Código de Barras.
              </Typography>
              */}
          </Typography>

          <Condicional condicao={rsClonePedido > 0}>
            <IconButton aria-label="delete" color="primary" onClick={() => pasteItensCopiados()}>
              <ContentPaste />
            </IconButton>
          </Condicional>

        </Grid>

        <Condicional condicao={rsStatusForm === StatusFormEnum.PESQUISANDO}>

          <Grid item xs={12}>

            <PesquisarTabela<rsERPProdutoInterface>
              setState={setPesquisa}
              field='ID_PRODUTO'
              fieldSet='idProduto'
              label='Produto'
              dados={pesquisa}
              campoQueryPesquisaID='ID_PRODUTO'
              campoQueryPesquisa='pesquisa'
              camposRetornoQueryPesquisa='{ID_PRODUTO CODIGO_AUXILIAR NOME ATIVO ID_UNIDADE_MEDIDA QTDE_NAO_FRACIONADA}'
              campoLabelQueryPesquisa='NOME'
              nomeQueryPesquisa='getERPProduto'
              nomeQueryPesquisaID='getERPProdutoPorId'
              mensagemPesquisa='Procurando Produtos...'
              erros={erros}
              valorAtribuirLimpar={0}
              camposParaExibir={['NOME', 'ID_PRODUTO', 'CODIGO_AUXILIAR']}
              onChange={(rs: rsERPProdutoInterface) => onChangeProduto(rs)}
              inputUpperCase
            />

          </Grid>

          <Grid item xs={12} sx={{ mt: 3 }}>
            <DataTable
              dados={rsProdutos}
              cabecalho={Cabecalho}
              acoes={[
                {
                  icone: 'add',
                  toolTip: '',
                  onAcionador: (rs: rsConsultaPrecoInterface) => onAdicionarProduto(rs),
                  // onDisabled: ( rs ) => ( rs.estoque <= 0 && !rs.permitirEstoqueNegativo ) || rs.dados?.valorSugerido <= 0
                  onDisabled: (rs: rsConsultaPrecoInterface) => (process.env.REACT_APP_ID_EMPRESA_SOMENTE_CONSULTA?.split(",").includes(rs.empresaIdentificador.toString())) || false
                }
              ]}

            />
          </Grid>

          <Grid item xs={12} sx={{ mt: 3 }}>
            <DataTable
              dados={rsPedidoItens}
              cabecalho={CabecalhoItens}
              acoes={[
                {
                  icone: 'delete',
                  toolTip: 'Apagar Item',
                  onAcionador: (_rs: rsERPEstoqueProdutoInterface, indice) => onApagarProduto(indice),
                  onDisabled: (rs) => rs.SALDO_QTD <= 0
                },
                {
                  icone: 'edit',
                  toolTip: 'Editar Item',
                  onAcionador: (_rs: rsERPEstoqueProdutoInterface, indice) => onEditarProduto(indice),
                  onDisabled: (rs) => rs.SALDO_QTD <= 0
                },
                {
                  icone: 'tune',
                  toolTip: 'Editar Valor Unitário',
                  onAcionador: (_rs: rsERPEstoqueProdutoInterface, indice) => onEditarValorUnitario(indice),
                  onDisabled: (rs) => rs.SALDO_QTD <= 0
                }
              ]}

            />
          </Grid>

        </Condicional>

        <Condicional condicao={rsStatusForm === StatusFormEnum.EDITANDO_VALOR_UNITARIO}>
          <Dialog
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            open={rsStatusForm === StatusFormEnum.EDITANDO_VALOR_UNITARIO}
            onClose={() => btCancelarEdicaoValorUnitario()}
          >
            <Grid container sx={{ padding: 5 }}>
              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  {rsValorUnitario.produtoNome}
                </Typography>

                {/*
                <InputText
                dados={rsDados}
                field='descricaoProduto'
                label='Produto'
                disabled={true}
                />
                */}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  {rsValorUnitario.centroEstoque}
                </Typography>
                {/*
                <InputText
                  dados={rsDados}
                  field='descricaoCentroEstoque'
                  label='Estoque'
                  disabled={true}
                />
                */}
              </Grid>

              <Grid item xs={12}>
                <InputText
                  dados={rsValorUnitario}
                  field='valorUnitario'
                  label='Valor'
                  tipo='currency'
                  textAlign='right'
                  disabled={!rsDados.tipoDescontoAcrescimoUnitario}
                  setState={setRsValorUnitario}
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 2, textAlign: 'right' }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                  <Button variant='contained' onClick={() => btCancelarEdicaoValorUnitario()}>Cancelar</Button>
                  <Button variant='contained' onClick={() => onAlterarValorUnitario(rsValorUnitario)}>Confirmar</Button>
                </Stack>
              </Grid>

            </Grid>

          </Dialog>
        </Condicional>

        <Condicional condicao={rsStatusForm === StatusFormEnum.EDITANDO_PRODUTO}>

          <Dialog
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            open={rsStatusForm === StatusFormEnum.EDITANDO_PRODUTO}
            onClose={() => btCancelarItem()}
          >

            <Grid container sx={{ padding: 5 }}>

              <Grid item xs={12}>
                <Typography variant="h6" gutterBottom>
                  {rsDados.produtoNome}
                </Typography>

                {/*
                <InputText
                dados={rsDados}
                field='descricaoProduto'
                label='Produto'
                disabled={true}
                />
                */}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="body1" gutterBottom>
                  {rsDados.centroEstoque}
                </Typography>
                {/*
                <InputText
                  dados={rsDados}
                  field='descricaoCentroEstoque'
                  label='Estoque'
                  disabled={true}
                />
                */}
              </Grid>

              <Grid item xs={12}>
                <InputText
                  dados={rsDados}
                  field='valorUnitario'
                  label='Valor'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6} sx={{ pr: 1 }}>
                <InputText
                  dados={rsDados}
                  field='estoque'
                  label='Saldo'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6}>
                <InputText
                  dados={rsDados}
                  field='quantidade'
                  label='Quantidade'
                  tipo='currency'
                  scale={rsDados.qtde_nao_fracionada ? 0 : 3}
                  textAlign='right'
                  erros={erros}
                  onChange={(rs: number) => onAlterarQuantidade(rs)}
                  mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('btConfirmarItem', 'button') }]}
                />
              </Grid>

              <Grid item xs={6} >
                <InputText
                  dados={{ valorTotal: vrCasasDecimais(rsDados.valorUnitario * rsDados.quantidade) }}
                  field='valorTotal'
                  label='Valor Total'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6} sx={{ pl: 1, mt: 3.5, textAlign: 'right', alignContent: 'end', justifyContent: 'flex-end' }}>
                <InputText
                  dados={rsDados}
                  field='tipoDescontoAcrescimoUnitario'
                  label='Aplciar D/A Unitário'
                  tipo='checkbox'
                  textAlign='right'
                  onChange={(rs) => onAlterarTipoDescontoAcrescimoUnitario(rs)}
                />
              </Grid>

              <Condicional condicao={rsDados.tipoDescontoAcrescimoUnitario}>

                <Grid item xs={6} >
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='percDescontoUnitario'
                    label='% Desconto'
                    tipo='currency'
                    textAlign='right'
                    onChange={(rs: number) => onAlterarPerDesconto(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('valorDescontoUnitario', 'text') }]}
                    erros={erros}
                  />
                </Grid>

                <Grid item xs={6} sx={{ pl: 1 }}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='valorDescontoUnitario'
                    label='$ Desconto'
                    tipo='currency'
                    textAlign='right'
                    onChange={(rs: number) => onAlterarValorDesconto(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('percAcrescimoUnitario', 'text') }]}
                    erros={erros}
                  />
                </Grid>

                <Grid item xs={6} sx={{ pr: 1 }}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='percAcrescimoUnitario'
                    label='% Acréscimo'
                    tipo='currency'
                    textAlign='right'
                    setState={setRsDados}
                    erros={erros}
                    onChange={(rs: number) => onAlterarPerAcrescimo(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('valorAcrescimoUnitario', 'text') }]}
                  />
                </Grid>

                <Grid item xs={6}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='valorAcrescimoUnitario'
                    label='$ Acréscimo'
                    tipo='currency'
                    textAlign='right'
                    setState={setRsDados}
                    erros={erros}
                    onChange={(rs: number) => onAlterarValorAcrescimo(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('btConfirmarItem', 'button') }]}
                  />
                </Grid>

              </Condicional>

              <Condicional condicao={!rsDados.tipoDescontoAcrescimoUnitario}>

                <Grid item xs={6} >
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='percDesconto'
                    label='% Desconto'
                    tipo='currency'
                    textAlign='right'
                    onChange={(rs: number) => onAlterarPerDesconto(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('valorDesconto', 'text') }]}
                    erros={erros}
                  />
                </Grid>

                <Grid item xs={6} sx={{ pl: 1 }}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='valorDesconto'
                    label='$ Desconto'
                    tipo='currency'
                    textAlign='right'
                    onChange={(rs: number) => onAlterarValorDesconto(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('percAcrescimo', 'text') }]}
                    erros={erros}
                  />
                </Grid>

                <Grid item xs={6} sx={{ pr: 1 }}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='percAcrescimo'
                    label='% Acréscimo'
                    tipo='currency'
                    textAlign='right'
                    setState={setRsDados}
                    erros={erros}
                    onChange={(rs: number) => onAlterarPerAcrescimo(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('valorAcrescimo', 'text') }]}
                  />
                </Grid>

                <Grid item xs={6}>
                  <InputText
                    dados={rsDados}
                    disabled={rsDados.quantidade <= 0}
                    field='valorAcrescimo'
                    label='$ Acréscimo'
                    tipo='currency'
                    textAlign='right'
                    setState={setRsDados}
                    erros={erros}
                    onChange={(rs: number) => onAlterarValorAcrescimo(rs)}
                    mapKeyPress={[{ key: 'Enter', onKey: () => focarCampo('quantidade', 'text') }]}
                  />
                </Grid>

              </Condicional>

              <Grid item xs={6} sx={{ pr: 1 }}>
                <InputText
                  dados={rsDados}
                  field='percDescTrib'
                  label='% Desc. Tributário'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6}>
                <InputText
                  dados={rsDados}
                  field='valorDescontoTrib'
                  label='Vr Desc. Tributário'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6} sx={{ pr: 1 }}>
                <InputText
                  dados={rsDados}
                  field='percDesoneracao'
                  label='% Desoneração ICMS'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={6}>
                <InputText
                  dados={rsDados}
                  field='valorDesoneracao'
                  label='$ Desoneração ICMS'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={12}>
                <InputText
                  dados={rsDados}
                  field='valorLiquido'
                  label='Valor a Pagar'
                  tipo='currency'
                  disabled={true}
                  textAlign='right'
                />
              </Grid>

              <Grid item xs={12} sx={{ mt: 2, textAlign: 'right' }}>
                <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
                  <Button variant='contained' onClick={() => btCancelarItem()}>Cancelar</Button>
                  <Button variant='contained' name='btConfirmarItem' onClick={() => btConfirmarItem()}>Confirmar</Button>
                </Stack>
              </Grid>

            </Grid>

            <ExibirJSONDev exibir={EMDESENVOLVIMENTO}
              oque={['Dadoos', rsDados]} />

          </Dialog>

        </Condicional>

      </Grid >

      <ExibirJSONDev exibir={EMDESENVOLVIMENTO}
        oque={['Dadoos', rsDados]} />

    </>
  )

}